// extracted by mini-css-extract-plugin
module.exports = {"honer":"honor_honer__ZbDgx","con":"honor_con__7qdne","warp":"honor_warp__2F16B","itm":"honor_itm__GRMLj","img":"honor_img__10pYu","dec":"honor_dec__32-vn","tet":"honor_tet__13Xwg"};